
import { PuttSituation } from "@/types/golf";

export const shortChips: PuttSituation = {
  id: 9,
  name: "Chips courts",
  image: "/lovable-uploads/4a716662-6dcc-4a19-aaf2-c2e0a705a22b.png",
  description: "Sur le green d'approche ou sur le parcours choisissez un trou et matérialisez la position de départ de cette situation de jeu. Placer une marque au point C=10m disposée entre le bord du green et un trou à 7 m minimum du bord de green. Jouez ensuite 10 balles.",
  distances: [
    { point: "C", distance: 10, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 4 },
    { condition: "Balle à moins de 1m", points: 2 },
    { condition: "Balle entre 1m et 2m", points: 1 },
    { condition: "Balle au-delà de 2m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 39 },
    { points: 1, index: 36 },
    { points: 2, index: 33 },
    { points: 3, index: 30 },
    { points: 4, index: 27 },
    { points: 5, index: 24 },
    { points: 6, index: 21 },
    { points: 7, index: 18 },
    { points: 8, index: 15 },
    { points: 9, index: 12 },
    { points: 10, index: 9 },
    { points: 11, index: 7 },
    { points: 12, index: 5 },
    { points: 13, index: 3 },
    { points: 14, index: 2 },
    { points: 15, index: 1 },
    { points: 16, index: 0 },
    { points: 17, index: -1 },
    { points: 18, index: -2 },
    { points: 19, index: -3 },
    { points: 20, index: -4 },
    { points: 21, index: -5 },
  ],
};
